import WrapperContainer from './styled/WrapperContainer';

export default WrapperContainer;
